import { render, staticRenderFns } from "./BidMarketContextPanel.vue?vue&type=template&id=03cba8c1&scoped=true"
import script from "./BidMarketContextPanel.vue?vue&type=script&lang=js"
export * from "./BidMarketContextPanel.vue?vue&type=script&lang=js"
import style0 from "./BidMarketContextPanel.vue?vue&type=style&index=0&id=03cba8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cba8c1",
  null
  
)

export default component.exports